<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">电机数据</span>
      <div style="flex:1;text-align: right;">
        <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
          <el-form-item :label="$t('time.timeQuery')">
            <el-date-picker v-model="queryTime" type="datetimerange" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="onQuery" type="primary">{{ $t('public.query') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button plain type="primary" @click="onExport">{{ $t('public.export') }}</el-button>
          </el-form-item>
        </el-form>

      </div>

    </div>
    <el-divider></el-divider>

    <!-- 数据表格 -->
    <div class="page_container">
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
  <el-table-column v-for="item in columns" :key="item.InterfaceField" :prop="item.InterfaceField" align="center" :label="item.LanguageTrans" :min-width="item.DisplayWidth?parseInt(item.DisplayWidth):80" ></el-table-column>
        <!-- <el-table-column prop="CarNo" align="center" label="车牌号" min-width="120"></el-table-column> -->
        <!-- <el-table-column prop="GpsDateTime" align="center" label="时间" min-width="180"></el-table-column>
        <el-table-column prop="driveMotorStatus" align="center" label="驱动电机状态" min-width="120"></el-table-column>
        <el-table-column prop="driveMotorControllerTemp" align="center" label="驱动电机控制器温度(℃)" min-width="140"></el-table-column>
        <el-table-column prop="driveMotorTemp" align="center" label="驱动电机温度(℃)" min-width="160"></el-table-column>
        <el-table-column prop="driveMotorSpeed" align="center" label="驱动电机转速(r/min)" min-width="140"></el-table-column> -->
        <!-- <el-table-column prop="CarNo" align="center" label="定位位置" min-width="120"></el-table-column> -->





      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo">
      </kl-pagination>
    </div>


  </div>
</template>

<script>
import quickQuery from "../components/generalOrQuickQuery.vue";
import { QueryAbroadCANMotor } from '@/http/vehicle'
import language from '@/utils/getLanguageId';
import { mapState } from 'vuex'
export default {
  name: 'EVMotorData',
  components: {
    quickQuery
  },
  computed: {
    LanguageId() {
      return language(this.$store.getters.locale)
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
      size: state => state.app.size
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      loading: false,
      queryTime: undefined,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,
      columns: []

    }
  },
  mounted() {
     this.queryFieldListByFunction();
    //queryTime 默认时间为当天0点到23:59:59
    this.queryTime = [new Date(), new Date()]
    this.beginDate = this.queryTime[0]
    this.endDate = this.queryTime[1]
    this.beginDate.setHours(0, 0, 0, 0)
    this.endDate.setHours(23, 59, 59, 999)

  },
  methods: {
     queryFieldListByFunction() {
      this.$api.queryFieldListByFunction({
        "FunctionName": "EVMotorData",
      }).then(res => {
        if (res.code == 200) {
          this.columns = res.data
        }
      })
    },
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].mobile + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = this.queryTime[0];
      this.endDate = this.queryTime[1];
      this.beginDate = this.beginDate.toLocaleString().replace(/\//g, '-')
      this.endDate = this.endDate.toLocaleString().replace(/\//g, '-')
      this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true

      // 实际项目中取消注释以下代码
      QueryAbroadCANMotor({
        "BeginTime": this.beginDate,
        "Language": this.LanguageId,
        "DeviceNo": this.getSelectedVehicles(),
        "EndTime": this.endDate,
        "IsExport": isExport,
        "TimeZone": 8,
        "PageNo": this.form.PageNo, "PageSize": this.form.PageSize
      }, isExport == 1 ? 'blob' : 'json').then(res => {
        this.loading = false
        if (isExport == 1) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码

          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download =  '电机数据.xlsx'; // 默认文件名
          // a.setAttribute(
          //     "download",
          //     "充电记录.xlsx"
          // ); // 表名，自定义
          // document.body.appendChild(a);
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
        } else {

          this.tableData = res.data || []
          this.total = res.recordsTotal || 0

        }
      })



    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
  }
}
</script>

<style scoped>
/* 响应式设计 */
</style>